import {
  Appointment,
  ASN,
  Audit,
  AuditResultPlace,
  BarcodedUnit,
  Batch,
  Carrier,
  Case,
  Client,
  ClientUser,
  Container,
  Damaged,
  Dock,
  Driver,
  DriverVisit,
  Facility,
  FreightOrder,
  FreightShipment,
  Market,
  Order,
  Pallet,
  PalletASN,
  ParcelOrder,
  ParcelShipment,
  Place,
  Product,
  Shipment,
  Sku,
  SupplyChainUser,
  Transload,
  Truckload,
} from 'src/api/models'
import { skuit } from 'src/services/skuit'

export * from './Routes'

type ObjectMap = { [objectType: string]: string }

const dashboardMap: ObjectMap = {}
dashboardMap[Appointment.type] = '/scheduling/appointments/{guid}'
dashboardMap[ASN.type] = '/v2/inbound/asns/{guid}'
dashboardMap[PalletASN.type] = '/v2/inbound/asns/{guid}'
dashboardMap[Audit.type] = '/inventory/audits/{guid}'
dashboardMap[AuditResultPlace.type] = '/inventory/audits/{guid}/places/{placeGuid}'
dashboardMap[BarcodedUnit.type] = '/inventory/barcoded-units/{guid}'
dashboardMap[Batch.type] = '/inventory/batches/{guid}'
dashboardMap[Carrier.type] = '/shipping/carriers/{guid}'
dashboardMap[Client.type] = '/v2/clients/{guid}'
dashboardMap[ClientUser.type] = '/v2/clients/{clientGuid}/users/{guid}'
dashboardMap[Container.type] = '/warehouse/containers/{guid}'
dashboardMap[Damaged.type] = '/v2/inventory/damages/{guid}'
dashboardMap[Dock.type] = '/warehouse/docks/{guid}'
dashboardMap[Driver.type] = '/shipping/drivers/{guid}'
dashboardMap[DriverVisit.type] = '/v2/warehouse/driver-visits/{guid}'
dashboardMap[Facility.type] = '/v2/warehouse/facilities/{guid}'
dashboardMap[FreightOrder.type] = '/v2/freight/orders/{guid}'
dashboardMap[FreightShipment.type] = '/v2/freight/shipments/{guid}'
dashboardMap[Market.type] = '/warehouse/markets/{guid}'
dashboardMap[Order.type] = '/inout/orders/{guid}'
dashboardMap[Pallet.type] = '/v2/inventory/pallets/{guid}'
dashboardMap[ParcelOrder.type] = '/v2/parcel/orders/{guid}'
dashboardMap[ParcelShipment.type] = '/v2/parcel/shipments/{guid}'
dashboardMap[Place.type] = '/warehouse/places/{guid}'
dashboardMap[Product.type] = '/v2/inventory/products/{guid}'
dashboardMap[Shipment.type] = '/inout/shipments/{guid}'
dashboardMap[Sku.type] = '/v2/inventory/skus/{guid}'
dashboardMap[SupplyChainUser.type] = 'supply-chain/users/{guid}'
dashboardMap[Truckload.type] = '/v2/freight/truckloads/{guid}'

const clientMap: ObjectMap = {}
clientMap[ASN.type] = '/asn/{guid}'
clientMap[Damaged.type] = '/inventory/damages/{guid}'
clientMap[Facility.type] = '/facilities/{guid}'
clientMap[FreightOrder.type] = '/freight/orders/{guid}'
clientMap[FreightShipment.type] = '/freight/shipments/{guid}'
clientMap[Pallet.type] = '/pallets/{guid}'
clientMap[ParcelOrder.type] = '/parcel/orders/{guid}'
clientMap[ParcelShipment.type] = '/parcel/shipments/{guid}'
clientMap[Sku.type] = '/inventory/skus/{guid}'
clientMap[Truckload.type] = '/freight/truckloads/{guid}'

const mapByType: { [type: string]: ObjectMap } = {
  client: clientMap,
  supply_chain: dashboardMap,
}

export const urlFor = (obj: any) => {
  if (!obj) {
    return null
  }
  const accountType = skuit.auth.getAccountType()
  const map = accountType ? mapByType[accountType] : null
  switch (obj.type) {
    case Case.type: {
      obj = obj.product
      break
    }
    case Transload.type: {
      obj = obj.asn
      break
    }
    case Container.type: {
      if (obj.containerType === 'pallet') {
        return '/v2/inventory/pallets/{guid}'.replace('{guid}', obj.guid).replace('{slug}', obj.slug)
      }
      break
    }
    case ClientUser.type: {
      if (map && obj.type in map) {
        const template = map[obj.type]
        return template.replace('{guid}', obj.guid).replace('{clientGuid}', obj.client.guid)
      }
      break
    }
    case AuditResultPlace.type: {
      if (map && obj.type in map) {
        const template = map[obj.type]
        return template.replace('{guid}', obj.audit.guid).replace('{placeGuid}', obj.place.guid)
      }
      break
     }
  }
  if (map && obj && obj.type in map) {
    const template = map[obj.type]
    return template.replace('{guid}', obj.guid).replace('{slug}', obj.slug)
  }
  return null
}
